import React, { useState, useEffect, useMemo } from "react";
import constants from "./constants";

export const MainContext = React.createContext({
  customers: null,
  machines: null,
  currentMachine: null,
  currentCustomer: null,
  isLoading: false,
  settings: null,
});

export const MainContextProvider = (props) => {
  const [customers, setCustomers] = useState([]);
  const [machines, setMachines] = useState([]);
  const [currentCustomer, setCurrentCustomer] = useState({});
  const [currentMachine, setCurrentMachine] = useState({});
  const [settings, setSettings] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const loadingProvider = useMemo(
    () => ({ isLoading, setIsLoading }),
    [isLoading, setIsLoading]
  );
  const settingsProvider = useMemo(
    () => ({ settings, setSettings }),
    [settings, setSettings]
  );

  const customersProvider = useMemo(
    () => ({ customers, setCustomers }),
    [customers, setCustomers]
  );

  const machinesProvider = useMemo(
    () => ({ machines, setMachines }),
    [machines, setMachines]
  );
  const customerProvider = useMemo(
    () => ({ currentCustomer, setCurrentCustomer }),
    [currentCustomer, setCurrentCustomer]
  );

  const machineProvider = useMemo(
    () => ({ currentMachine, setCurrentMachine }),
    [currentMachine, setCurrentMachine]
  );

  const fetchData = (cid) => {
    fetch(constants.apiUrl + cid, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log("cid " + cid);
          if (result) {
            setCustomers(result.customers);
            setCurrentCustomer(result.currentCustomer);
            setCurrentMachine(result.machines[0]);
            setMachines(result.machines);
            setSettings(result.settings);
          }
        },
        (error) => {
          console.log(JSON.stringify(error));
        }
      );
  };

  useEffect(() => {
    console.log("here");
    let customerID = currentCustomer.customerID;
    if (!Number.isInteger(customerID) || customerID == {}) {
      localStorage.setItem("cid", 1);
      customerID = 1;
    }
    fetchData(customerID);
  }, []);

  return (
    <MainContext.Provider
      value={{
        customers: customersProvider,
        currentCustomer: customerProvider,
        loading: loadingProvider,
        machines: machinesProvider,
        currentMachine: machineProvider,
        settings: settingsProvider,
      }}
    >
      {props.children}
    </MainContext.Provider>
  );
};
